<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">
      <div class="spacer2"></div>
      <div class="containter">
        <div class="mfhd">
          <i
            class="fa fa-angle-left pointer"
            [routerLink]="['/workspace']"
            aria-hidden="true"
            style="padding-right: 5px"
          ></i
          >{{ WSDetails?.workspace?.name }}
          <i
            class="fa-solid fa-circle-check"
            *ngIf="WSDetails?.workspace?.isDefault == true"
            style="color: #15b300"
          ></i>
          <i
            class="fa-solid fa-circle-check"
            *ngIf="WSDetails?.workspace?.isDefault == false"
            style="color: #8f8f8f"
          ></i>
          <div
            class="page-description"
            style="font-size: 14px; margin-top: 8px; margin-bottom: 8px"
          >
            <span style="color: #9c9b9b">Created On:</span>
            {{
              WSCreatedAt | tzfmt : "MMM dd, yyyy" : appService.TimeZoneName
            }}
          </div>
        </div>

        <div class="wsTable">
          <table [cellPadding]="10" [cellSpacing]="10">
            <tr>
              <th>ApiKey</th>
              <td>
                <div class="min fl-left" id="myInput">
                  {{ maskApiKey(WSDetails?.workspace?.apiKey) }}
                </div>
                <i
                  class="fa-solid fa-clone pointer fl-left routeClr"
                  [matTooltip]="getCopyTooltip(WSDetails?.workspace?.apiKey)"
                  (click)="copyMessage(WSDetails?.workspace?.apiKey)"
                  style="margin-left: 3px"
                ></i>
              </td>
              <td></td>
              <th>Status</th>
              <td>
                <span
                  style="color: #15b300"
                  *ngIf="WSDetails?.workspace?.status == 'ACTIVATED'"
                  >{{ WSDetails?.workspace?.status }}</span
                ><span
                  style="color: #9c9b9b"
                  *ngIf="WSDetails?.workspace?.status != 'ACTIVATED'"
                  >{{ WSDetails?.workspace?.status }}</span
                >
              </td>
            </tr>
            <tr>
              <th>Institution Name</th>
              <td>{{ WSDetails?.workspace?.institutionName }}</td>
              <td></td>
              <th>Institution Id</th>
              <td>{{ WSDetails?.workspace?.institutionId }}</td>
            </tr>
          </table>
        </div>

        <div class="spacer5"></div>

        <div class="card-container">
          <div class="card">
            <div class="cdesc">Plan</div>
            <div class="chd text-caps">{{ WSDetails?.usageSummary?.tier }}</div>
            <div class="cdiv"></div>
            <div class="cdesc">Monthly Limit</div>
            <div class="chd">{{ WSDetails?.usageSummary?.monthlyLimit }}</div>
          </div>

          <div class="card">
            <div class="cdesc">Memory Used</div>
            <div class="chd">{{ WSDetails?.usageSummary?.tokenConsumed }}</div>
            <div class="cdiv"></div>
            <div class="cdesc">Memory Remaining</div>
            <div class="chd">
              {{ WSDetails?.usageSummary?.tokensRemaining }}
            </div>
          </div>

          <div class="card">
            <div class="cdesc">Usage Percentage</div>
            <div class="chd">
              {{ WSDetails?.usageSummary?.usagePercentage }}
            </div>
            <div class="cdiv"></div>
            <div class="cdesc">Start Period</div>
            <div class="chd">
              {{ spdate | tzfmt : "MMM dd, yyyy" : appService.TimeZoneName }}
            </div>
          </div>
        </div>

        <div class="spacer5"></div>
        <button
          mat-raised-button
          color="primary"
          class="btn-send clr-white"
          style="float: right"
          (click)="generateNewKey()"
        >
          Generate New Key
        </button>
        <div><b>Key Pair(s)</b></div>
        <div class="spacer2"></div>

        <table
          mat-table
          [dataSource]="connectorKeys"
          class="mat-elevation-z8"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="keyType">
            <th mat-header-cell *matHeaderCellDef style="width: 20%">
              Key Type
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.keyType }}
            </td>
          </ng-container>

          <ng-container matColumnDef="publickey">
            <th mat-header-cell *matHeaderCellDef>PublicKey</th>
            <td
              mat-cell
              *matCellDef="let element"
              style="width: 65%;word-break: break-word"
            >
              {{ element.publickey }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">Status</th>
            <td mat-cell *matCellDef="let element">
              <!-- <mat-slide-toggle
                [(ngModel)]="element.expired"
                (change)="onChangeKeyStatus($event, element.id)"
              ></mat-slide-toggle> -->
            <mat-button-toggle
              [checked]="element.expired === true || element.expired === 'true'"
              (change)="onChangeKeyStatus(element)"
            >
              {{ element.expired === true || element.expired === 'true' ? 'Active' : 'Inactive' }}
            </mat-button-toggle>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedKeysColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedKeysColumns"
            class="main-row"
          ></tr>
        </table>

        <div class="spacer5"></div>
        <b
          ><a
            class="pointer routeClr"
            style="float: right; display: flex"
            (click)="addNewKey()"
          >
            <mat-icon>
              {{
                showAddNewKeyNav ? "keyboard_arrow_up" : "keyboard_arrow_down"
              }} </mat-icon
            >Add New Key
          </a></b
        >
        <div><b>LLM Keys</b><i
                  class="fa fa-info-circle pointer routeClr"
                  matTooltip="A unique token (string) issued to you by an LLM provider. Used to authenticate and authorize your access to the model's APIs."
                  style="margin-left: 3px"
                ></i></div>
        <div class="spacer-1"></div>
        <div class="form-fields addkeynav" *ngIf="showAddNewKeyNav">
          <form [formGroup]="addKeyForm">
            <div class="form-field" style="width: 100%">
              <mat-label class="wid-80px">Identifier*</mat-label>
              <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="form-input"
              >
                <input
                  matInput
                  class="filter-input"
                  [formControl]="identifierControl"
                />
              </mat-form-field>
            </div>

            <div class="spacer"></div>

            <div class="form-field" style="width: 100%">
              <mat-label class="wid-80px">Configure LLM Key*</mat-label>
              <mat-form-field
                appearance="fill"
                floatLabel="always"
                class="form-input"
              >
                <input
                  matInput
                  class="filter-input"
                  [formControl]="uploadKeyControl"
                />
              </mat-form-field>
            </div>

            <div class="spacer"></div>

            <div class="button-container" style="text-align: right">
              <button
                mat-raised-button
                (click)="submitLLMKey()"
                color="primary"
                class="btn-send clr-white"
                style="float: right; margin-right: 10px"
                title="Create new workspace"
              >
                Submit
              </button>
              <!-- <button
              mat-raised-button matStepperNext
              color="primary" [disabled]="uploadKeyControl.invalid"
              class="clr-white"
              (click)="submitLLMKey()"
            >
              {{ "Submit" }}
            </button> -->
            </div>
          </form>
        </div>

        <table
          mat-table
          [dataSource]="connectorLLMKeys"
          class="mat-elevation-z8"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef>Key</th>
            <td
              mat-cell
              *matCellDef="let element"
              style="width: 55%; white-space: pre-wrap; word-break: break-word"
            >
              {{ element.key }}
            </td>
          </ng-container>

          <ng-container matColumnDef="identifier">
            <th mat-header-cell *matHeaderCellDef style="width: 20%">
              Identifier
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.identifier }}
            </td>
          </ng-container>

          <ng-container matColumnDef="modelName">
            <th mat-header-cell *matHeaderCellDef style="width: 10%">
              Model Name
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.modelName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef style="width: 15%">Status</th>
            <td mat-cell *matCellDef="let element">
              <!-- <mat-slide-toggle
                [ngModel]="element.status === 'ACTIVE'"
                (change)="onChangeLLMKeyStatus($event, element)"
              >
              </mat-slide-toggle> -->
<mat-button-toggle
  [checked]="element.status === 'ACTIVE'"
  (change)="onChangeLLMKeyStatus(element)"
>
  {{ element.status === 'ACTIVE' ? 'Active' : 'Inactive' }}
</mat-button-toggle>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedLLMKeysColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedLLMKeysColumns"
            class="main-row"
          ></tr>
        </table>

        <div class="spacer5"></div>
      </div>
    </div>
  </div>
</div>
